import Fetcher from "./Shared/FetchService";
export default class AcademicPlanConfigurationService {
    static getAcademicPlanConfiguration() {
        return Fetcher.getSingleResponse("/aviso/academicPlanConfiguration/show", {
            format: "json",
        });
    }
}
